interface Props {
  width?: string;
  height?: string;
}

const RSUIcon = ({ height, width }: Props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      height={height || "52"}
      width={width || "50"}
      viewBox="0 0 512 512"
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path
          d="M1255 4740 c-346 -73 -617 -288 -770 -613 -81 -172 -117 -383 -97
    -564 57 -501 423 -887 918 -969 258 -42 539 17 758 160 444 289 620 846 422
    1332 -57 139 -118 227 -245 354 -168 167 -330 256 -546 301 -121 25 -317 25
    -440 -1z m450 -363 c117 -39 199 -91 295 -187 97 -97 154 -194 191 -325 32
    -112 32 -278 1 -390 -127 -447 -620 -671 -1037 -471 -196 93 -341 269 -401
    486 -27 98 -25 272 5 375 46 164 151 315 285 409 81 58 129 81 228 111 74 22
    97 25 218 22 114 -3 148 -8 215 -30z"
        />
        <path
          d="M1395 4132 c-40 -26 -71 -61 -84 -95 -6 -16 -11 -105 -11 -210 0
    -156 3 -188 19 -223 27 -60 327 -358 376 -374 48 -16 120 -8 154 17 36 27 69
    79 77 120 13 71 -9 109 -146 248 l-129 130 -3 146 c-3 134 -5 148 -27 180 -38
    55 -69 73 -136 77 -46 2 -67 -1 -90 -16z"
        />
        <path
          d="M3715 3686 c-40 -17 -82 -67 -96 -114 -15 -52 2 -112 47 -161 41 -46
    90 -61 196 -61 l73 0 -539 -539 -539 -539 -179 223 c-123 154 -189 228 -212
    239 -42 20 -112 21 -147 2 -33 -17 -1501 -1127 -1548 -1170 -106 -98 -67 -259
    71 -297 87 -23 0 -83 1152 790 197 149 362 270 367 269 4 -2 90 -107 192 -234
    122 -153 194 -234 213 -242 53 -21 81 -24 125 -12 40 10 105 73 672 638 l627
    627 0 -98 c0 -103 6 -124 49 -170 54 -59 122 -72 196 -38 49 22 73 48 91 98
    17 48 20 646 3 690 -13 34 -55 80 -91 99 -38 20 -678 20 -723 0z"
        />
        <path
          d="M4075 2416 c-22 -13 -49 -39 -60 -58 -19 -32 -20 -55 -25 -843 l-5
    -810 -335 0 -335 0 -5 435 c-4 379 -7 439 -21 465 -22 40 -47 61 -93 80 -74
    31 -178 -12 -215 -88 -20 -42 -21 -57 -21 -470 l0 -427 -335 0 -334 0 -3 483
    -3 483 -28 43 c-37 56 -80 81 -140 81 -59 0 -117 -28 -149 -72 l-23 -33 -5
    -490 -5 -490 -337 -3 -338 -2 0 127 c0 109 -3 133 -21 171 -45 91 -147 122
    -239 71 -71 -39 -84 -72 -90 -229 l-5 -135 -140 -5 c-161 -6 -194 -18 -233
    -86 -46 -79 -9 -198 75 -240 37 -18 91 -19 2018 -19 1844 0 1982 1 2011 17 46
    25 90 81 98 122 13 71 -30 158 -95 191 -20 11 -64 15 -164 15 l-135 0 0 795
    c0 861 2 835 -53 893 -54 58 -143 69 -212 28z"
        />
      </g>
    </svg>
  );
};

export default RSUIcon;
